export type EventTypes =
  | "widget_opened"
  | "widget_closed"
  | "channel_selected"
  | "powered_by_fuzey_opened"
  | "widget_auto_opened";
  
  
export default class WidgetAnalyticsService {
  public static async post(
    merchant_uuid: string,
    user_id: string,
    event_type: EventTypes,
    channel_id?: string
  ) {
    try {
       await fetch(
        `${process.env.REACT_APP_FUZEY_API_URL}/public/widget/${merchant_uuid}/analytics`,
        {
          method: "POST",
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            user_id,
            event_type,
            channel_id,
          }),
        }
      );

    } catch (e) {
      return null;
    }
  }
}
